module.exports = __webpack_public_path__ + "assets/img/11_1101.5159307d.jpg";